import { Box, Button, Tab, InputBase, Chip } from "@mui/material";
import React, { FC, useRef, useState } from "react";
import { PageHeading } from "../../Components/page-heading.component";
import threedots from "../../assets/images/threedots.svg";
import ModalComponent from "../../Components/modal.component";
import InputTextField from "../../Components/text-field.component";
import {
  DatePickerComponent,
  DatePickerInput,
  DatePickerRenderInput,
} from "../../Components/date-picker.component";
import { PrimaryButton } from "../../Components/primary-button.component";
import { useNavigate } from "react-router-dom";
import { PaymentService } from "../../Services/payment.service";
import { GetAllDto } from "../../Shared/dto/get-all-dto";
import { useEffect } from "react";
import {
  PaymentModel,
  PaymentClass,
  pendingAmount,
  receivedAmount,
  paymentValidationSchema,
} from "../../Models/payment.model";
// import PaymentReceived from "./PaymentReceived/PaymentReceived.lazy";
import PaymentReceived from "./PaymentReceived/PaymentReceived";
import { ContactModal } from "../../Components/select-contact";
import { styled, alpha } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import { ProjectService } from "../../Services/project.service";
import Receivable from "../../Pages/Payment/Receivable/Receivable";
import {
  DropdownInput,
  IOption,
} from "../../Components/dropdown-input-component";
import { DisplayDate } from "../../Shared/services/date-format";
import { useLoading } from "../../Shared/services/loading-context";
import { useSnackbar } from "notistack";
import { useFormik } from "formik";
import * as yup from "yup";
import { DisplayAmount } from "../../Shared/services/amount-format";

// import PaymentReceived from "./PaymentReceived/PaymentReceived.lazy";

interface PaymentProps {
  contactId?: number;
}

const Payment: FC<PaymentProps> = (props) => {
  const [isReceiveModalOpen, setIsReceiveModalOpen] = useState<any>(false);
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [isCustomerModalOpen, setIsCustomerModalOpen] =
    useState<boolean>(false);
  const [paymentFields, setPaymentFields] = useState<PaymentModel>(
    new PaymentClass()
  );
  const [isFlatSelectionModalOpen, setIsFlatSelectionModalOpen] =
    useState<any>(false);
  const [modalSelectionNumber, setModalSelectionNumber] = useState<number>(1);
  const [towerData, setTowerData] = useState<any[]>([]);
  const [floorData, setFloorData] = useState<any[]>([]);
  const [flatData, setFlatData] = useState<any[]>([]);
  const [blockNumbers, setBlockNumber] = useState<any[]>([]);
  const [receivableList, setReceivableList] = useState<any[]>([]);
  const { loading, setLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();

  const MeetingStyle = {
    width: "1100px",
    minHeight: "700px",
    background: "#F3F3F3;",
  };

  const openReceiveModal = () => {
    getReceiptNo();
    setIsReceiveModalOpen(true);
  };

  const getReceiptNo = async () => {
    setLoading(true);
    const response = await PaymentService.getReceiptNo();
    setLoading(false);
    if (response.success) {
      setPaymentFields({ ...paymentFields, receiptNumber: response.data });
    } else {
      enqueueSnackbar(response.message ?? "Internal server error", {
        variant: "error",
      });
    }
  };

  const navigate = useNavigate();

  const redirectReceived = () => {
    navigate("/payment/paymentReceived");
  };

  const redirectReceivable = () => {
    navigate("/payment");
  };

  const contactDetails = () => {
    setIsCustomerModalOpen(true);
  };

  const selectCustomer = (currElem: any) => {
    paymentFields.contactName = currElem.name;
    setIsCustomerModalOpen(false);
  };

  /**
   * Onchange Function
   */
  const paymentInputField = (e: any) => {
    formik.handleChange(e);
    const data: any = paymentFields;
    data[e.target.name] = e.target.value;
    data.paidAmount = receivedAmount(data);
    setPaymentFields({ ...data });
  };

  const style = {
    border: "none",
    width: "560px",
    height: "612px",
    background: "#FFFFFF",
    boxShadow: "0px 0px 10px 3px rgb(2 4 4 / 7%)",
    borderRadius: "15px",
    overflow: "scroll",
  };

  const closeFlatSelectionModal = () => {
    setIsFlatSelectionModalOpen(false);
  };

  const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#9D9D9D",
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    "& .MuiInputBase-input": {
      padding: theme.spacing(1, 1, 1, 0),
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("md")]: {
        width: "auto",
      },
    },
  }));

  const Search = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    background: "#FFFFFF",
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "213px",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "213px",
      float: "right",
      borderRadius: "10px",
      height: "40px",
    },
  }));

  /**
   * Payment Mode DropDown
   */
  const paymentMode: IOption[] = [
    { key: 1, value: "Cash", text: "Cash" },
    { key: 2, value: "Cheque", text: "Cheque" },
    { key: 3, value: "NEFT", text: "NEFT" },
    { key: 4, value: "RTGS", text: "RTGS" },
    { key: 5, value: "IMPS", text: "IMPS" },
    { key: 6, value: "Demand Draft", text: "Demand Draft" },
    { key: 7, value: "UPI", text: "UPI" },
    { key: 8, value: "PhonePe", text: "PhonePe" },
    { key: 9, value: "Google pay", text: "Google pay" },
    { key: 10, value: "Paytm", text: "Paytm" },
    { key: 11, value: "Online", text: "Online" },
    { key: 12, value: "Debit Card", text: "Debit Card" },
    { key: 12, value: "Credit Card", text: "Credit Card" },
  ];

  /**
   * Receivable Get Api
   */
  const getReceivableData = async () => {
    if (!(paymentFields?.id && paymentFields?.id >= 0)) {
      setIsFlatSelectionModalOpen(true);
      const getAllDto = new GetAllDto("");
      setLoading(true);
      const response = await PaymentService.getReceivableData(getAllDto);
      setLoading(false);

      if (response.success) {
        setReceivableList(response.data);
      } else
        enqueueSnackbar(response.message ?? "Internal server error", {
          variant: "error",
        });
    }
  };

  /**
   * Invoice Data
   * @param data
   */
  const sendReceivableData = (data: any) => {
    formik.setFieldValue("contactName", data.contactName);
    setIsFlatSelectionModalOpen(false);
    const record = { ...paymentFields };
    record.invoiceNumberShow = data.invoiceNumber;
    record.invoiceDateShow = data.invoiceDate;
    record.contactNameShow = data.contactName;
    record.blockNumberShow = data.blockNumber;
    record.totalAmountShow = data.totalAmount;
    record.paidAmountShow = data.paidAmount;
    record.salesId = data.id;
    record.flatId = data.flatId;
    record.pendingAmountShow = pendingAmount(record);
    setPaymentFields({ ...record });
  };

  const closeReceiveModal = () => {
    setIsReceiveModalOpen(false);
    setPaymentFields(new PaymentClass());
  };

  const childRef = useRef<any>();

  /**
   * Post Api
   */
  const editPayment = async (id: any) => {
    setLoading(true);
    const response = await PaymentService.getById(id);
    setLoading(false);
    if (response.success) {
      const record = { ...response.data };
      const data = { ...record.paymentReceivable };
      record.invoiceNumberShow = data.invoiceNumber;
      record.invoiceDateShow = data.invoiceDate;
      record.contactNameShow = data.contactName;
      record.blockNumberShow = data.blockNumber;
      record.totalAmountShow = data.totalAmount;
      record.paidAmountShow = data.paidAmount;
      record.salesId = data.id;
      record.flatId = data.flatId;
      record.pendingAmountShow = pendingAmount({ ...record });
      setPaymentFields(record);
    } else
      enqueueSnackbar(response.message ?? "Internal server error", {
        variant: "error",
      });
    setIsReceiveModalOpen(true);
  };

  /**
   * Payment Received Add Api
   */
  const saveData = async () => {
    const data: any = { ...paymentFields };
    data.basicAmount = Number(data.basicAmount);
    data.gstCharges = Number(data.gstCharges);
    data.otherCharges = Number(data.otherCharges);
    data.receiptNumber = Number(data.receiptNumber);
    delete data.paymentReceivable;
    delete data.flat;
    delete data.sales;
    delete data.contactNameShow;
    delete data.invoiceDateShow;
    delete data.invoiceNumberShow;
    delete data.totalAmountShow;
    delete data.blockNumberShow;
    delete data.paidAmountShow;
    delete data.pendingAmountShow;
    setLoading(true);
    const response = await PaymentService.save(data);
    setLoading(false);
    if (response.success) {
      setIsReceiveModalOpen(false);
      setPaymentFields(new PaymentClass());
      setTabIndex(1);
      enqueueSnackbar(response.message, { variant: "success" });
    } else
      enqueueSnackbar(response.message ?? "Internal server error", {
        variant: "error",
      });
    childRef?.current?.receivedListingData();
  };

  const validationSchema = yup.object(paymentValidationSchema);

  const formik = useFormik({
    initialValues: new PaymentClass(),
    validationSchema: validationSchema,
    onSubmit: saveData,
  });

  const receivedListingData = (searchQuery?: string) => {
    if (childRef?.current?.receivedListingData)
      childRef?.current?.receivedListingData(searchQuery);
    else if (childRef?.current?.receivableListingData)
      childRef?.current?.receivableListingData(searchQuery);
  };

  return (
    <div>
      <PageHeading
        title="Payment"
        addNew={openReceiveModal}
        hasFilter={true}
        onSearch={receivedListingData}
      />
      <Box className="button-box-payment">
        <Button
          className={tabIndex == 0 ? "active" : String()}
          onClick={() => setTabIndex(0)}
        >
          Receivable
        </Button>

        <Button
          className={tabIndex == 1 ? "active" : String()}
          onClick={() => setTabIndex(1)}
        >
          Received
        </Button>

        <Button
          className={tabIndex == 2 ? "active" : String()}
          onClick={() => setTabIndex(2)}
        >
          Payable
        </Button>
      </Box>

      {!props.contactId && <div className="d-flex">
        <Box className="payment-total-amount">
          <div className="d-flex line-height-totalamount">
            <span className="totalamount-text">Total Amount :</span>
            <span className="amount-value"> ₹123,1230.000</span>
          </div>
        </Box>
        <Box className="payment-due-amount">
          <div className="d-flex line-height-totalamount">
            <span className="total-due-text">Total Due Amount :</span>
            <span className="due-value">₹123,1230.00</span>
          </div>
        </Box>
      </div>}

      <div>
        {tabIndex == 0 && <Receivable contactId={props.contactId} />}
        {tabIndex == 1 && (
          <PaymentReceived ref={childRef} contactId={props.contactId} editPayment={editPayment} />
        )}
        {tabIndex == 2 && <>Pending</>}
      </div>

      <ModalComponent
        isModalOpen={isReceiveModalOpen}
        style={MeetingStyle}
        customHeader={false}
        title="Receive Payment"
        hideModal={closeReceiveModal}
      >
        <form onSubmit={formik.handleSubmit}>
          <Box className="payment-form">
            <InputTextField
              name="contactName"
              onClick={getReceivableData}
              label="Contact name"
              value={paymentFields.contactNameShow ?? ""}
              onChange={() => { }}
              disabled
              helperText={
                formik.touched.contactName && formik.errors.contactName
              }
              error={
                formik.touched.contactName && Boolean(formik.errors.contactName)
              }
            />

            <InputTextField
              name=""
              onClick={getReceivableData}
              label="Property"
              value={paymentFields.blockNumberShow ?? ""}
              disabled
            />

            <InputTextField
              label="Invoice no"
              onClick={getReceivableData}
              disabled
              value={paymentFields.invoiceNumberShow ?? ""}
            />
            <InputTextField
              onClick={getReceivableData}
              label="Total amount"
              disabled
              value={paymentFields.totalAmountShow ?? ""}
              onChange={() => { }}
            />
            <InputTextField
              onClick={getReceivableData}
              disabled
              label="Paid amount"
              value={paymentFields.paidAmountShow ?? ""}
              onChange={() => { }}
            />
            <InputTextField
              disabled
              onClick={getReceivableData}
              label="Pending amount"
              name=""
              value={paymentFields.pendingAmountShow ?? ""}
              onChange={() => { }}
            />
            <InputTextField
              value={paymentFields.receiptNumber ?? ""}
              name="receiptNumber"
              label="Receipt Number"
              onChange={(e) => {
                paymentInputField(e);
              }}
              helperText={
                formik.touched.receiptNumber && formik.errors.receiptNumber
              }
              error={
                formik.touched.receiptNumber &&
                Boolean(formik.errors.receiptNumber)
              }
            />
            <InputTextField
              value={paymentFields.basicAmount ?? ""}
              name="basicAmount"
              label="Basic amount"
              type="number"
              onChange={(e) => {
                paymentInputField(e);
              }}
              helperText={
                formik.touched.basicAmount && formik.errors.basicAmount
              }
              error={
                formik.touched.basicAmount && Boolean(formik.errors.basicAmount)
              }
            />
            <InputTextField
              value={paymentFields.gstCharges ?? ""}
              name="gstCharges"
              type="number"
              label="GST"
              onChange={(e) => {
                paymentInputField(e);
              }}
              helperText={formik.touched.gstCharges && formik.errors.gstCharges}
              error={
                formik.touched.gstCharges && Boolean(formik.errors.gstCharges)
              }
            />
            <InputTextField
              value={paymentFields.otherCharges ?? ""}
              name="otherCharges"
              label="Other charges"
              type="number"
              onChange={(e) => {
                paymentInputField(e);
              }}
              helperText={
                formik.touched.otherCharges && formik.errors.otherCharges
              }
              error={
                formik.touched.otherCharges &&
                Boolean(formik.errors.otherCharges)
              }
            />

            <InputTextField
              value={paymentFields.refNo ?? ""}
              name="refNo"
              label="Reference no"
              onChange={(e) => {
                paymentInputField(e);
              }}
            />

            <DatePickerComponent
              key={new Date().getTime() + "one"}
              label="Payment date"
              inputFormat="dd/MM/yyyy"
              value={paymentFields.created_at}
              onChange={(e: any) =>
                paymentInputField({
                  target: { name: "created_at", value: e },
                })
              }
              error={
                formik.touched.created_at && Boolean(formik.errors.created_at)
              }
              helperText={formik.touched.created_at && formik.errors.created_at}
            />

            <DropdownInput
              value={paymentFields.paymentMode}
              label="Payment mode"
              name="paymentMode"
              options={paymentMode}
              onChange={(e) => {
                paymentInputField(e);
              }}
              helperText={
                formik.touched.paymentMode && formik.errors.paymentMode
              }
              error={
                formik.touched.paymentMode && Boolean(formik.errors.paymentMode)
              }
            />

            <DatePickerComponent
              key={new Date().getTime() + "two"}
              label="Next due date"
              inputFormat="dd/MM/yyyy"
              value={paymentFields.dueDate}
              onChange={(e: any) =>
                paymentInputField({
                  target: { name: "dueDate", value: e },
                })
              }
            />
          </Box>
          <Box className=" d-flex receive-SaveBox">
            <div className="d-grid">
              <span className="payment-amount">
                {DisplayAmount(paymentFields.paidAmount || 0)}
              </span>
              <span className="payment-received-text">Recevied Amount</span>
            </div>
            <div className="receive-Save-btn">
              <PrimaryButton
                type="submit"
                style={{ width: "108px", marginTop: "15px" }}
              >
                Save
              </PrimaryButton>
            </div>
          </Box>
        </form>
      </ModalComponent>

      {/* Invoice field modal starts */}
      <ModalComponent
        style={style}
        isModalOpen={isFlatSelectionModalOpen}
        customHeader={false}
        hideModal={closeFlatSelectionModal}
      >
        <Search className="modalSearch">
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search here"
            inputProps={{ "aria-label": "search" }}
          />
        </Search>

        {receivableList.map((currElem) => {
  return (
    <Box
      key={currElem.id || currElem.invoiceNumber} // ✅ Add unique key here
      className="payment-invoice-box"
      onClick={() => {
        sendReceivableData(currElem);
      }}
    >
      <div>
        <span className="payment-invoice-no">
          {currElem.invoiceNumber} ({DisplayDate(currElem.invoiceDate)})
        </span>
        <div className="d-flex justify-content-between mt-3">
          <span>Name</span>
          <span>{currElem.contactName}</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>Mobile</span>
          <span>{currElem.mobileNo}</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>Total Amount</span>
          <span>&#8377;{currElem.totalAmount}</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>Paid Amount</span>
          <span>
            {currElem.paidAmount !== 0 ? currElem.paidAmount : <></>}
          </span>
        </div>
        <div></div>
      </div>
      <span className="invoice-blockno">{currElem.blockNumber}</span>
    </Box>
  );
})}

      </ModalComponent>
    </div>
  );
};

export default Payment;
